import styled from 'styled-components';

export const ContainerFinancialToReceiveList = styled.div`
  max-height: 500px;
  overflow: auto;
`;
